module.exports =
{

  _init: function ()
  {
    this.onNext()
  },

  onNext: function ()
  {

    $('#modal-submit').not('.js-ignore').click(function ()
    {

      this.disabled = true

      $('.modal-body').text('Loading...')

      var signup_account_id = $('#modal-signup_account_id').val()

      APPLICATION._APPLICATION.customModal(
        APPLICATION._PATH_PREFIX + 'fibre-node/edit?signup_account_id=' + signup_account_id,
        'FibreNode',
        'edit'
      )

    }).addClass('js-ignore')

  }

}